import { invert, zip } from 'lodash'

import { FontFamilyType } from 'utils/fontUtils'

export const fontWeightValidator = (fontWeightName: string): boolean => {
  return Object.values(WeightNamesMap).includes(fontWeightName as any)
}

export const WeightNames = [
  'Thin',
  'Extra Light',
  'Light',
  'Regular',
  'Medium',
  'Semi Bold',
  'Bold',
  'Extra Bold',
  'Black',
] as const

export const WeightValues = ['100', '200', '300', '400', '500', '600', '700', '800', '900'] as const
export type WeightValue = (typeof WeightValues)[number]
export type WeightName = (typeof WeightNames)[number]

export const WeightNamesMap: Record<WeightValue, WeightName> = Object.fromEntries(zip(WeightValues, WeightNames))

export const WeightValuesMap = invert(WeightNamesMap) as Record<WeightName, WeightValue>
export const AvailableWeights: Record<FontFamilyType, WeightValue[]> = {
  Alegreya: ['400', '500', '600', '700', '800', '900'],
  'Alegreya Sans': ['100', '300', '400', '500', '700', '800', '900'],
  'Andada Pro': ['400', '500', '600', '700', '800'],
  Anton: ['400'],
  Archivo: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Archivo Narrow': ['400', '500', '600', '700'],
  Arial: ['400', '700', '800'],
  'Arial Black': ['400'],
  Arvo: ['400', '700'],
  Barlow: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  BioRhyme: ['200', '300', '400', '700', '800'],
  Cabin: ['400', '500', '600', '700'],
  Cardo: ['400', '700'],
  Catamaran: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Caveat: ['400', '500', '600', '700'],
  Chivo: ['300', '400', '700', '900'],
  'Comic Sans MS': ['400', '700'],
  'Concert One': ['400'],
  Cormorant: ['300', '400', '500', '600', '700'],
  'Courier New': ['400', '700'],
  'Crimson Pro': ['200', '300', '400', '500', '600', '700', '800', '900'],
  'Dancing Script': ['400', '500', '600', '700'],
  'DM Sans': ['400', '500', '700'],
  Domine: ['400', '500', '600', '700'],
  Dosis: ['200', '300', '400', '500', '600', '700', '800'],
  'EB Garamond': ['400', '500', '600', '700', '800'],
  Eczar: ['400', '500', '600', '700', '800'],
  'Encode Sans': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Enriqueta: ['400', '500', '600', '700'],
  Epilogue: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Fira Sans': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Georgia: ['400', '700'],
  Hahmlet: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Helvetica Neue': [],
  'IBM Plex Mono': ['100', '200', '300', '400', '500', '600', '700'],
  'IBM Plex Sans': ['100', '200', '300', '400', '500', '600', '700'],
  'IBM Plex Serif': ['100', '200', '300', '400', '500', '600', '700'],
  Impact: ['400'],
  Inconsolata: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Inknut Antiqua': ['300', '400', '500', '600', '700', '800', '900'],
  'Inria Serif': ['300', '400', '700'],
  Inter: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'JetBrains Mono': ['100', '200', '300', '400', '500', '600', '700', '800'],
  'Josefin Sans': ['100', '200', '300', '400', '500', '600', '700'],
  Jost: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Karla: ['200', '300', '400', '500', '600', '700', '800'],
  Lato: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Libre Baskerville': ['400', '700'],
  'Libre Franklin': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Lobster Two': ['400', '700'],
  Lora: ['400', '500', '600', '700'],
  Manrope: ['200', '300', '400', '500', '600', '700', '800'],
  'Maven Pro': ['400', '500', '600', '700', '800', '900'],
  Merriweather: ['300', '400', '700', '900'],
  Montserrat: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Mukta: ['200', '300', '400', '500', '600', '700', '800'],
  Neuton: ['200', '300', '400', '700', '800'],
  Newsreader: ['200', '300', '400', '500', '600', '700', '800'],
  'Noto Sans': ['400', '700'],
  Nunito: ['200', '300', '400', '500', '600', '700', '800', '900'],
  'Nunito Sans': ['200', '300', '400', '600', '700', '800', '900'],
  'Old Standard TT': ['400', '700'],
  'Open Sans': ['300', '400', '500', '600', '700', '800'],
  Oswald: ['200', '300', '400', '500', '600', '700'],
  Oxygen: ['300', '400', '700'],
  Pacifico: ['400'],
  'Permanent Marker': ['400'],
  Play: ['400', '700'],
  'Playfair Display': ['400', '500', '600', '700', '800', '900'],
  Prompt: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'Proza Libre': ['400', '500', '600', '700', '800'],
  Poppins: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  'PT Sans': ['400', '700'],
  'PT Serif': ['400', '700'],
  Quicksand: ['300', '400', '500', '600', '700'],
  Raleway: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Recursive: ['300', '400', '500', '600', '700', '800', '900'],
  Roboto: ['100', '300', '400', '500', '700', '900'],
  'Roboto Condensed': ['300', '400', '700'],
  'Roboto Mono': ['100', '200', '300', '400', '500', '600', '700'],
  'Roboto Slab': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Rosario: ['300', '400', '500', '600', '700'],
  Rosarivo: ['400'],
  Rubik: ['300', '400', '500', '600', '700', '800', '900'],
  'Saira Condensed': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  Signika: ['300', '400', '500', '600', '700'],
  Sora: ['100', '200', '300', '400', '500', '600', '700', '800'],
  'Source Code Pro': ['200', '300', '400', '500', '600', '700', '800', '900'],
  'Source Sans Pro': ['200', '300', '400', '600', '700', '900'],
  'Source Serif Pro': ['200', '300', '400', '600', '700', '900'],
  'Space Grotesk': ['300', '400', '500', '600', '700'],
  'Space Mono': ['400', '700'],
  Spectral: ['200', '300', '400', '500', '600', '700', '800'],
  Syne: ['400', '500', '600', '700', '800'],
  'Times New Roman': ['400', '700'],
  'Titillium Web': ['200', '300', '400', '600', '700', '900'],
  'Trebuchet MS': ['400', '700'],
  Ubuntu: ['300', '400', '500', '700'],
  'Ubuntu Mono': ['400', '700'],
  Verdana: ['400', '700'],
  Vollkorn: ['400', '500', '600', '700', '800', '900'],
  'Work Sans': ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
}
